export enum IdentityVerificationOrigin {
  UBBLE = 'UBBLE',
  SWAN = 'SWAN',
  DOCUMENTS = 'DOCUMENTS',
  IMPORT = 'IMPORT',
}
